import React from 'react';
import PropTypes from 'prop-types';
import {
    FormattedMessage,
    FormattedDate,
    FormattedTime,
} from 'react-intl';
import styled from 'styled-components';
import { rgba } from 'polished';
import dayjs from 'dayjs';

import Colours from '../definitions/Colours';
import Sizes from '../definitions/Sizes';


function LastEditedBanner({ children, lastEditDate, ...otherProps }) {
    const isLastEditedToday = lastEditDate
        ? dayjs().isSame(dayjs(lastEditDate), 'day')
        : true; // REQUIREMENT: If we don't have a lastEditDate, assume it's Today

    return (
        <div {...otherProps}>
            <If condition={children}>
                <span className="main-information">
                    {children}
                </span>
            </If>

            <span 
                className="last-edit rh-text-s" 
                suppressHydrationWarning // prevent hydration warning if server timezone is different than browser timezone
            >
                <FormattedMessage
                    id="Base-ui.LastEditedBanner.lastEdited"
                    defaultMessage="Last modified: {isLastEditedToday, select,
                        true {Today}
                        other {{dateFormatted} at {timeFormatted}}
                    }"
                    values={{
                        isLastEditedToday,
                        dateFormatted: (
                            <FormattedDate
                                value={lastEditDate}
                                year="numeric"
                                month="long"
                                day="2-digit"
                            />
                        ),
                        timeFormatted: (
                            <FormattedTime
                                value={lastEditDate}
                                hour="numeric"
                                minute="numeric"
                            />
                        ),
                    }}
                />
            </span>
        </div>
    );
}

LastEditedBanner.propTypes = {
    lastEditDate: PropTypes.string,
    children: PropTypes.element,
};

const StyledLastEditedBanner = styled(LastEditedBanner)`
    display: -ms-grid;
    display: grid;

    -ms-grid-columns: 1fr ${Sizes.SPACING.ONE} auto ${Sizes.SPACING.ONE} 1fr;
    grid-template-columns: 1fr auto 1fr;
    grid-column-gap: ${Sizes.SPACING.ONE};

    align-items: center;

    padding: ${Sizes.SPACING.ONE};
    background-color: ${rgba(Colours.STONE_LIGHT, 0.6)};
    
    > .main-information {
        -ms-grid-column: 3;
        grid-column: 2;

        margin: 0;
        text-align: center;
    }

    > .last-edit {
        -ms-grid-column: 5;
        grid-column: 3;

        margin: 0;

        color: ${Colours.STONE_DARKEST};
        text-align: right;
    }
`;

export default StyledLastEditedBanner;